import React, { Suspense, lazy, useCallback, useState } from "react";
import { patientFromRow } from "../staff/launch";

// The picker and the fill screen are lazy chunks: the cards, menu, pCard,
// chart panel and inbox that offer "Staff form" only gain this file.
const StaffFormsDialog = lazy(() => import("./StaffFormsDialog"));

/*
 * const [openStaffForm, staffFormFill] = useStaffFormFill();
 *   openStaffForm(row, opts)   row: a dashboard / chart / pCard row (patientid,
 *                              appointmentid, name, dob) or null (pick a patient)
 *     opts.submissionId        open that staff form (draft / saved) directly
 *     opts.mode                "staff_sections": a patient submission's staff parts
 *     opts.startEditing        open a saved form in the editor
 *     opts.formId              start that internal form for the patient
 *     opts.dob, opts.onDone(result)
 *   {staffFormFill}            render it anywhere in the caller
 */
export function useStaffFormFill() {
  const [target, setTarget] = useState(null);
  const open = useCallback((row, opts = {}) => {
    setTarget({
      patient: patientFromRow(row, opts.dob),
      appointmentid: (row && row.appointmentid) || null,
      submissionId: opts.submissionId || null,
      formId: opts.formId || null,
      mode: opts.mode || "internal",
      startEditing: !!opts.startEditing,
      onDone: opts.onDone || null,
      key: Date.now(),
    });
  }, []);
  const element = target ? (
    <Suspense fallback={null}>
      <StaffFormsDialog
        key={target.key}
        open
        patient={target.patient}
        appointmentid={target.appointmentid}
        submissionId={target.submissionId}
        formId={target.formId}
        mode={target.mode}
        startEditing={target.startEditing}
        onClose={(res) => {
          const cb = target.onDone;
          setTarget(null);
          if (cb) cb(res || {});
        }}
      />
    </Suspense>
  ) : null;
  return [open, element];
}

export default useStaffFormFill;
